import { metaHelper, type BuilderMeta } from '@customerio/dryad';
import { createBuilderHook } from '@customerio/dryad-react';
import { PEOPLE_FILTER_FORMAT, PEOPLE_FILTER_MAX_DEPTH, peopleFilterAdapter } from './people-filter-format';

// Views are registered in people-filter-builder.tsx, not here: a row needs
// this builder for its typed useMeta/useLeafState reads, so importing rows
// into this module would be circular.

export type { TypeOption, TypeOptionGroup } from '@/features/dryad';

/**
 * The shared meta (isDisabled, typeOptions, merged into dryad's BuilderMeta by
 * features/dryad) plus the fields only this surface's rows read.
 */
export type PeopleFilterBuilderMeta = BuilderMeta & {
  /** Redaction: the attribute row disables its inputs when false. */
  canViewAttributeValues: boolean;
  /**
   * Opens the inline create-segment form, told which segment row asked so the
   * created segment can fill that row in place. Undefined where the shortcut
   * isn't offered (the viewer can't create segments, or this is the nested
   * builder inside the create form itself) — the segment row then leaves the
   * entry out of its picker.
   */
  onCreateSegment?: (nodeId: string) => void;
};

export const peopleFilterBuilder = createBuilderHook({
  formatAdapters: { [PEOPLE_FILTER_FORMAT]: peopleFilterAdapter },
  maxDepth: PEOPLE_FILTER_MAX_DEPTH,
  meta: metaHelper<PeopleFilterBuilderMeta>(),
});
